var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIncomeandExpenditureAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.1445 41.5264C26.8285 41.5264 24.0391 42.9475 24.0391 43.8947C24.0391 44.8419 26.776 46.263 31.1445 46.263C35.513 46.263 38.25 44.8419 38.25 43.8947C38.25 42.9475 35.4605 41.5264 31.1445 41.5264Z",
    fill: "url(#paint0_linear_3403_144007)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0391 50.579V52.6316C24.0391 53.5788 26.776 54.9999 31.1445 54.9999C35.513 54.9999 38.25 53.5788 38.25 52.6316V50.579C36.5656 51.6315 33.829 52.2105 31.1445 52.2105C28.46 52.2105 25.7231 51.684 24.0391 50.579Z",
    fill: "url(#paint1_linear_3403_144007)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0391 46.2632V48.3158C24.0391 49.263 26.776 50.6842 31.1445 50.6842C35.513 50.6842 38.25 49.263 38.25 48.3158V46.2632C36.5656 47.3157 33.829 47.8947 31.1445 47.8947C28.46 47.8947 25.7231 47.3157 24.0391 46.2632Z",
    fill: "url(#paint2_linear_3403_144007)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.30469 41.8948V43.9474C8.30469 44.8946 11.0416 46.3157 15.4102 46.3157C19.7261 46.3157 22.5156 44.8946 22.5156 43.9474V41.8948C20.8312 42.9473 18.0946 43.5263 15.4102 43.5263C12.7257 43.4738 9.98909 42.9477 8.30469 41.8948Z",
    fill: "url(#paint3_linear_3403_144007)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.30469 46.2632V48.3158C8.30469 49.263 11.0416 50.6842 15.4102 50.6842C19.7261 50.6842 22.5156 49.263 22.5156 48.3158V46.2632C20.8312 47.3157 18.0946 47.8947 15.4102 47.8947C12.7257 47.8422 9.98909 47.3157 8.30469 46.2632Z",
    fill: "url(#paint4_linear_3403_144007)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.30469 50.579V52.6316C8.30469 53.5788 11.0416 54.9999 15.4102 54.9999C19.7261 54.9999 22.5156 53.5788 22.5156 52.6316V50.579C20.8312 51.6315 18.0946 52.2105 15.4102 52.2105C12.7257 52.2105 9.98909 51.684 8.30469 50.579Z",
    fill: "url(#paint5_linear_3403_144007)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.30469 37.5265V39.5791C8.30469 40.5263 11.0416 41.9475 15.4102 41.9475C19.7261 41.9475 22.5156 40.5263 22.5156 39.5791V37.5265C20.8312 38.579 18.0946 39.158 15.4102 39.158C12.7257 39.1055 9.98909 38.5794 8.30469 37.5265Z",
    fill: "url(#paint6_linear_3403_144007)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3555 32.7896C11.0395 32.7896 8.25 34.2107 8.25 35.1579C8.25 36.1051 10.9869 37.5262 15.3555 37.5262C19.6714 37.5262 22.4609 36.1051 22.4609 35.1579C22.4609 34.2107 19.724 32.7896 15.3555 32.7896Z",
    fill: "url(#paint7_linear_3403_144007)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7225 31.7895C50.8803 24.6841 47.4594 15.8948 41.4594 12.579L45.3542 8.78948C46.7754 7.42115 45.7753 5 43.8281 5H28.7754C26.7753 5 25.7752 7.42125 27.2493 8.78948L31.0913 12.579C25.0913 15.8949 21.6702 24.6842 19.8281 31.7369C22.1965 32.3684 23.9858 33.5263 23.9858 35.1578V41.5788C25.6702 40.5263 28.4068 39.9473 31.0913 39.9473C35.3019 39.9473 39.7753 41.3157 39.7753 43.8947V44.4212C41.4597 44.3687 42.9859 44.2108 44.3542 44.0526C50.3017 43.3683 54.1963 37.579 52.7229 31.7894L52.7225 31.7895ZM41.1962 22.1579C41.1962 22.3683 41.0383 22.5265 40.8276 22.5265H38.4593C38.775 23.0001 39.0382 23.5266 39.1436 24.1056H40.828C41.0384 24.1056 41.1966 24.2634 41.1966 24.4742V25.8953C41.1966 26.1057 41.0387 26.2639 40.828 26.2639H39.1436C38.67 28.4219 36.7224 30.001 34.4594 30.001H34.1437L38.8803 34.7905C38.9857 34.8959 39.0382 35.0538 38.9328 35.1591C38.8803 35.317 38.7749 35.3695 38.6171 35.3695L36.4595 35.3688C36.3541 35.3688 36.2491 35.3163 36.1962 35.2634L31.512 30.4738C31.4595 30.4213 31.4066 30.316 31.4066 30.2106V28.0526C31.4066 27.8422 31.5645 27.684 31.7752 27.684H34.5122C35.5123 27.684 36.4069 27.105 36.8281 26.2103H31.8282C31.6178 26.2103 31.4596 26.0524 31.4596 25.8417V24.4206C31.4596 24.2102 31.6174 24.052 31.8282 24.052H36.8281C36.407 23.1573 35.5123 22.5783 34.5122 22.5783H31.7752C31.5649 22.5783 31.4066 22.4204 31.4066 22.2097V20.6835C31.4066 20.4732 31.5645 20.3149 31.7752 20.3149H40.8279C41.0383 20.3149 41.1965 20.4728 41.1965 20.6835L41.1962 22.1579Z",
    fill: "url(#paint8_linear_3403_144007)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3403_144007",
    x1: 37.3068,
    y1: 42.0632,
    x2: 34.2147,
    y2: 50.8927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B4963"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09152F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3403_144007",
    x1: 37.3068,
    y1: 51.08,
    x2: 34.5746,
    y2: 59.4387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B4963"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09152F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3403_144007",
    x1: 37.3068,
    y1: 46.7642,
    x2: 34.5746,
    y2: 55.1229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B4963"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09152F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3403_144007",
    x1: 21.5724,
    y1: 42.3958,
    x2: 18.8403,
    y2: 50.7545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B4963"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09152F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3403_144007",
    x1: 21.5724,
    y1: 46.7642,
    x2: 18.8403,
    y2: 55.1229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B4963"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09152F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3403_144007",
    x1: 21.5724,
    y1: 51.08,
    x2: 18.8403,
    y2: 59.4387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B4963"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09152F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3403_144007",
    x1: 21.5724,
    y1: 38.0275,
    x2: 18.8403,
    y2: 46.3862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B4963"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09152F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3403_144007",
    x1: 21.5177,
    y1: 33.3264,
    x2: 18.4256,
    y2: 42.1559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B4963"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09152F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3403_144007",
    x1: 50.8314,
    y1: 9.46773,
    x2: 10.57,
    y2: 41.7468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B4963"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09152F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncomeandExpenditureAccount);
export default __webpack_public_path__ + "static/media/IncomeandExpenditureAccount.38df9553c318790e5e94e0c2ff5d1d4c.svg";
export { ForwardRef as ReactComponent };